import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PromotionType } from './types'

export const initialState = {
  data: [] as PromotionType[],
}

const promotionSlice = createSlice({
  name: 'promotion',
  initialState,
  reducers: {
    setPromotions(state, { payload }: PayloadAction<PromotionType[]>) {
      state.data = payload
    },
  },
})

export type PromotionStateType = typeof initialState

export const {
  setPromotions,
} = promotionSlice.actions
export const promotionReducer = promotionSlice.reducer
